import { render, staticRenderFns } from "./d-back-button.vue?vue&type=template&id=5c9916ce&scoped=true&"
import script from "./d-back-button.vue?vue&type=script&lang=js&"
export * from "./d-back-button.vue?vue&type=script&lang=js&"
import style0 from "./d-back-button.vue?vue&type=style&index=0&id=5c9916ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9916ce",
  null
  
)

export default component.exports